export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 100;
export const RESULTS_PER_PAGE = 10;
export const KEY = '11556a13-5e0d-4bcf-96cf-132ba0d89f13';
export const MODAL_CLOSE_SEC = 2;

//`https://forkify-api.jonas.io/api/v2/recipes/
